<template>
<div class="nctouch-cart-container">
    <div class="nctouch-cart-block mt5"> <a href="javascript:void(0);" @click="paymentShow" class="posr">
        <h3>支付方式</h3>
        <div class="current-con">{{paymentTypeName}}</div>
        <i class="icon-arrow" v-if="allowOffline"></i> </a>
    </div>
    <!--选择付款方式Begin-->
    <div id="select-payment-wrapper" :class="['nctouch-full-mask',paymentWrapperClass]">
        <div class="nctouch-full-mask-bg"></div>
        <div class="nctouch-full-mask-block">
            <div class="header">
                <div class="header-wrap">
                    <div class="header-l"> <a href="javascript:void(0);" @click="goBack" > <i class="back"></i> </a> </div>
                    <div class="header-title">
                        <h1>选择支付方式</h1>
                    </div>
                </div>
            </div>
            <div class="nctouch-main-layout">
                <div class="nctouch-sel-box">
                    <h4 class="tit">支付方式</h4>
                    <div class="sel-con"> <a href="javascript:void(0);" :class="{sel:paymentTypeCode == 'online'}" @click="choosePayment('online')" id="payment-online"><i></i>在线支付</a> <a href="javascript:void(0);" @click="choosePayment('offline')" :class="{sel:paymentTypeCode == 'offline'}" ><i></i>货到付款</a></div>
                </div>
            </div>
        </div>
    </div>
    <!--选择付款方式End-->
</div>
</template>
<script>
    // js 区域 


    export default {
        //外部传入参数
        props: {
            allowOffline: false
        },
        /*
         * 自身数据,一定要一个function
         */
        data: function() {
            return {
                paymentWrapperClass: 'hide',
                paymentTypeCode: 'online'
            }
        },
        /**
         * 计算属性
         */
        computed: {
            paymentTypeName: function(){
                return this.paymentTypeCode == "online" ? "在线支付" : "货到付款"
            }
        },

        /**
         * 监听属性变动
         */
        watch: {

        },
        /**
         * 过滤器
         */
        filters: {

        },
        /**
         * 自定义方法
         */
        methods: {
            /**
             * 显示选择支付方式界面
             */
            paymentShow: function(){
                if (!this.allowOffline) {
                    return;
                }
                this.paymentWrapperClass = "left";
            },
            /**
             * 选择支付方式
             **/
            choosePayment : function(paymentTypeCode) {
                this.paymentWrapperClass = 'right';
                this.paymentTypeCode = paymentTypeCode;
                this.$emit('choose-payment', paymentTypeCode);
            },
            /**
             * 返回
             **/
            goBack: function(){
                this.paymentWrapperClass = "right";
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/buy-payment/buy-payment.vue